/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ComponentFill24Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 24, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ComponentFill24Icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2354 2.83998C12.7788 2.58313 12.2212 2.58313 11.7646 2.83998L4.76461 6.77748C4.29229 7.04315 4 7.54293 4 8.08484V15.9151C4 16.4571 4.29229 16.9568 4.76461 17.2225L11.7646 21.16C12.2212 21.4169 12.7788 21.4169 13.2354 21.16L20.2354 17.2225C20.7077 16.9568 21 16.4571 21 15.9151V8.08484C21 7.54293 20.7077 7.04315 20.2354 6.77747L13.2354 2.83998ZM12.2549 3.71155C12.4071 3.62593 12.5929 3.62593 12.7451 3.71155L19.4801 7.49999L12.5 11.4263L5.51987 7.49999L12.2549 3.71155ZM5 8.35491V15.9151C5 16.0958 5.09743 16.2624 5.25487 16.3509L12 20.1451V12.2924L5 8.35491ZM13 20.1451L19.7451 16.3509C19.9026 16.2624 20 16.0958 20 15.9151V8.35491L13 12.2924V20.1451Z"
            fill="currentColor"
          />
          <g opacity="0.4">
            <path
              d="M12.5 9.6169C12.5 10.0056 12.076 10.2456 11.7428 10.0457L8.21458 7.92875C7.89091 7.73454 7.89091 7.26545 8.21458 7.07125L11.7428 4.95435C12.076 4.75439 12.5 4.99445 12.5 5.3831V9.6169Z"
              fill="currentColor"
            />
            <path
              d="M10.2854 13.4287C10.6091 13.2345 10.6091 12.7655 10.2854 12.5713L6.75725 10.4543C6.42399 10.2544 6 10.4944 6 10.8831V15.1169C6 15.5056 6.42399 15.7456 6.75725 15.5457L10.2854 13.4287Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ComponentFill24Icon.tags = [
  '3D',
  'cube',
  'change',
  'perspective',
  'transform',
  'geometric',
  'rotate',
  'prism',
];

ComponentFill24Icon.category = '24x24';

ComponentFill24Icon.iconSize = 24;
